import { useHoverStore } from "@/components/Inputs/RangePicker/stores/useHoverStore.ts";
import { useShadowRoot } from "@/helpers/ShadowRootContext.ts";
import { RefObject, useEffect } from "react";

export const useRangePickerOutsideInteractions = (
  dayPickerRef: RefObject<HTMLDivElement | null>,
  setHideDatePicker: (value: boolean) => void,
) => {
  const { shadowRoot } = useShadowRoot();
  const setHoveredDate = useHoverStore((state) => state.setHoveredDate);

  useEffect(() => {
    const pickerRef = dayPickerRef.current;

    const handleClickOutside = (event: Event) => {
      if (pickerRef && !pickerRef.contains(event.target as Node)) {
        setHideDatePicker(true);
      }
    };

    const handleMouseLeave = () => setHoveredDate(null);
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setHideDatePicker(true);
      }
    };

    shadowRoot.addEventListener("mousedown", handleClickOutside);
    pickerRef?.addEventListener("mouseleave", handleMouseLeave);
    pickerRef?.addEventListener("keypress", handleKeyPress);

    return () => {
      shadowRoot.removeEventListener("mousedown", handleClickOutside);
      pickerRef?.removeEventListener("mouseleave", handleMouseLeave);
      pickerRef?.removeEventListener("keypress", handleKeyPress);
    };
  }, [dayPickerRef, setHoveredDate, shadowRoot, setHideDatePicker]);
};
